import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';

/**
 * 活动-模块
 */
var sourceCastle = {
  path: '/sourceCastle',
  component: RootLayout,
  redirect: '/sourceCastle/index',
  children: [
  // 源堡 start
  {
    path: '/sourceCastle/index',
    name: 'SourceCastle',
    component: function component() {
      return import('@/views/sourceCastle/Index');
    },
    meta: {
      title: '源堡实验室'
    }
  }, {
    path: '/sourceCastle/rules',
    name: 'SourceCastleRules',
    component: function component() {
      return import('views/sourceCastle/Rules');
    },
    meta: {
      title: '活动细则'
    }
  }, {
    path: '/sourceCastle/bioBank',
    name: 'BioBank',
    component: function component() {
      return import('views/sourceCastle/BioBank');
    },
    meta: {
      title: '生物仓'
    }
  }, {
    path: '/sourceCastle/parsingRecord',
    name: 'ParsingRecord',
    component: function component() {
      return import('views/sourceCastle/ParsingRecord');
    },
    meta: {
      title: '解析记录'
    }
  }, {
    path: '/sourceCastle/elementiumRecord',
    name: 'ElementiumRecord',
    component: function component() {
      return import('views/sourceCastle/ElementiumRecord');
    },
    meta: {
      title: '源质记录',
      keepAlive: true
    }
  }, {
    path: '/sourceCastle/elementiumDetail',
    name: 'ElementiumDetail',
    component: function component() {
      return import('views/sourceCastle/ElementiumDetail');
    },
    meta: {
      title: '源质详情'
    }
  }, {
    path: '/sourceCastle/parsingSource',
    name: 'ParsingSource',
    component: function component() {
      return import('views/sourceCastle/ParsingSource');
    },
    meta: {
      title: '解析源码'
    }
  }, {
    path: '/sourceCastle/sourceUpgrade',
    name: 'SourceUpgrade',
    component: function component() {
      return import('@/views/sourceCastle/SourceUpgrade');
    },
    meta: {
      title: '源码升级'
    }
  }, {
    path: '/sourceCastle/selectAddress',
    name: 'SelectAddress',
    component: function component() {
      return import('@/views/sourceCastle/components/SelectAddress');
    },
    meta: {
      title: '选择地址'
    }
  }, {
    path: '/sourceCastle/addressInfo',
    name: 'SourceAddressInfo',
    component: function component() {
      return import('@/views/sourceCastle/components/AddressInfo');
    },
    meta: {
      title: '地址信息'
    }
  }, {
    path: '/sourceCastle/findAddressInfo',
    name: 'FindAddressInfo',
    component: function component() {
      return import('@/views/sourceCastle/components/FindAddressInfo');
    },
    meta: {
      title: '查看收货地址'
    }
  }]
};
export default sourceCastle;